import {useTranslation} from "../../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialBox from "../../../../../__snowpack__/pkg/@mui/material/Box.js";
import MaterialCheckbox from "../../../../../__snowpack__/pkg/@mui/material/Checkbox.js";
import MaterialTableHead from "../../../../../__snowpack__/pkg/@mui/material/TableHead.js";
import MaterialTableRow from "../../../../../__snowpack__/pkg/@mui/material/TableRow.js";
import React from "react";
import TableCell from "../table-cell/table-cell.component.js";
import {IconContainer} from "./table-head.styles.js";
function TableHead({
  dataLength,
  headers,
  limit,
  onOrderingChange,
  onRowSelectAll,
  ordering,
  selectable,
  fixSelect,
  selectedRows = [],
  ...rest
}) {
  const {
    t
  } = useTranslation();
  const bxShadow = headers.map((cells) => cells.fixLeft).includes(true);
  return /* @__PURE__ */ React.createElement(MaterialTableHead, rest, /* @__PURE__ */ React.createElement(MaterialTableRow, null, selectable && /* @__PURE__ */ React.createElement(TableCell, {
    $bxShadow: !bxShadow,
    $fixWidth: 0,
    $fixLeft: fixSelect,
    padding: "checkbox"
  }, /* @__PURE__ */ React.createElement(MaterialCheckbox, {
    checked: dataLength === selectedRows.length || limit === selectedRows.length,
    color: "primary",
    indeterminate: selectedRows.length > 0 && selectedRows.length < dataLength,
    onChange: onRowSelectAll
  })), headers.map((header, index) => {
    const fixWidth = selectable && header.fixLeft && fixSelect ? 46 : 0;
    const showOrdering = ordering && header.sortName && String(Object.keys(ordering)) === header.sortName;
    return /* @__PURE__ */ React.createElement(TableCell, {
      $fixWidth: fixWidth,
      $header: true,
      $hidden: header.hidden,
      $pointer: header.sortable,
      $bxShadow: bxShadow,
      $fixLeft: header.fixLeft,
      $fixRight: header.fixRight,
      key: index,
      translate: header.translate,
      onClick: () => header.sortable && header.sortName && onOrderingChange && onOrderingChange(header.sortName)
    }, /* @__PURE__ */ React.createElement(MaterialBox, {
      alignItems: "center",
      display: "flex"
    }, header.label || (header.translate ? t(header.translate) : ""), showOrdering && /* @__PURE__ */ React.createElement(IconContainer, null, ordering && Object.values(ordering)[0] === "ASC" ? "arrow_downward" : "arrow_upward")));
  })));
}
export default /* @__PURE__ */ React.memo(TableHead);
